import request from '@/utils/request'

export default {
    fetchAfms() {
        return request.get('/market/afms')
    }
}
